<template class="ml-3">
	<div class="mx-3">
		<v-flex class="mx-4 rounded-lg" ref="container" row>
			<v-hover
				class="col-lg-4 col-xl-3 my-4 cursor-default"
				v-for="(stat, index) in stats"
				:key="index"
			>
				<template v-slot="{ hover }">
					<div class="px-3">
						<v-card
							class="rounded-lg pa-5 transition-swing"
							color="white"
							ripple
							:class="`elevation-${hover ? 14 : 1}`"
						>
							<v-flex class="content-card" row>
								<v-col class="col-md-4 pl-4 ">
									<v-avatar
										:size="80"
										tile
										class="rounded-lg align-self-center"
										:color="theme.accent"
									>
										<template v-if="stat.image">
											<v-img :src="stat.image" :alt="`[${stat.name}]`" />
										</template>
										<template v-else>
											<span class="white--text headline">{{
												getInitials(stat)
											}}</span>
										</template>
									</v-avatar>
								</v-col>
								<v-col class="col-md-8">
									<div class="font-weight-bold mb-1 mt-0 stat-full-name">
										{{ stat.name }}
									</div>
									<div
										class="font-weight-light text--disabled font-under-normal"
									>
										@{{ stat.username }}
									</div>
								</v-col>
							</v-flex>
							<v-flex
								row
								class="mt-2 pb-4 rounded-lg border pa-2 ma-0 justify-space-between"
								:style="{ 'border-color': `whitesmoke !important` }"
							>
								<v-card-title
									class="card-title text-truncate course-name border rounded-lg pa-0 px-2 mt-2 font-small"
									:style="{
										'border-color': `${stat.level.color} !important`,
									}"
									>{{ stat.level.name }} • {{ stat.level.level }}
								</v-card-title>
								<v-card-title class="card-title pa-0 pl-5 mt-2"
									>Grade {{ stat.grade }}</v-card-title
								>
								<div class="activity-sparkline pa-3 rounded-lg">
									<v-sparkline
										class="mt-2 flip-y"
										width="70"
										height="6"
										:value="getActivity(stat.activity)"
										:color="theme.accent"
										smooth
										:padding="5"
										:line-width="1.5"
										stroke-linecap="round"
										gradient-direction="top"
										type="trend"
										auto-draw
									></v-sparkline>
								</div>
							</v-flex>

							<v-flex row class="pa-2 pt-1 pl-0">
								<v-subheader>Course</v-subheader>
								<div class="col-12 py-0 mx-4">
									<div class="text--primary pt-2 pl-0">
										<div
											class="card-title font-small pb-4"
											v-for="(r, index) in stat.course"
											:key="index"
										>
											<v-flex row class="pa-0">
												<div class="stat-label">
													{{ r.subject }}
												</div>
												<div class="stat-sparkline ml-3">
													<v-sparkline
														class="mt-2"
														width="70"
														height="6"
														:value="[0, 0, 0]"
														:color="r.color"
														smooth
														:padding="5"
														:line-width="1.5"
														stroke-linecap="round"
														gradient-direction="right"
														type="trend"
														auto-draw
													></v-sparkline>
												</div>
												<div class="pl-3">{{ r.amount }}</div>
											</v-flex>
										</div>
										<div class="card-title font-small">
											<v-flex row class="pa-0">
												<div class="stat-label">
													Total
												</div>
												<div class="stat-sparkline ml-3">
													<v-sparkline
														class="mt-2"
														width="70"
														height="6"
														:value="[0, 0, 0]"
														:color="theme.accent"
														smooth
														:padding="5"
														:line-width="1.5"
														stroke-linecap="round"
														gradient-direction="right"
														type="trend"
														auto-draw
													></v-sparkline>
												</div>
												<div class="pl-3">{{ stat.total.course.amount }}</div>
											</v-flex>
										</div>
									</div>
								</div>

								<v-flex row class="justify-space-between pa-0 ma-0">
									<v-subheader class="pt-3">Quiz </v-subheader>
									<v-subheader class="pt-3">Average </v-subheader>
								</v-flex>
								<div class="col-12 py-0 mx-4">
									<div class="text--primary pt-2 pl-0">
										<div
											class="card-title font-small pb-4"
											v-for="(r, index) in stat.quiz"
											:key="index"
										>
											<v-flex row class="pa-0 justify-space-between">
												<v-flex row class="pa-0 ma-0">
													<div class="stat-label">
														{{ r.subject }}
													</div>
													<div class="stat-sparkline ml-3">
														<v-sparkline
															class="mt-2"
															width="70"
															height="6"
															:value="[0, 0, 0]"
															:color="r.color"
															smooth
															:padding="5"
															:line-width="1.5"
															stroke-linecap="round"
															gradient-direction="right"
															type="trend"
															auto-draw
														></v-sparkline>
													</div>
													<div class="pl-3">{{ r.amount }}</div>
												</v-flex>
												<div
													class="caption text-center rounded-circle pa-1 grey-bg average-container"
													:style="{
														'background-color':
															r.amount == 0
																? theme.light
																: r.average >= 50
																? theme.success_light
																: theme.error_light,
													}"
												>
													{{ r.average }}
												</div>
											</v-flex>
										</div>
										<div class="card-title font-small">
											<v-flex row class="pa-0 justify-space-between">
												<v-flex row class="pa-0 ma-0">
													<div class="stat-label">
														Total
													</div>
													<div class="ml-3 stat-sparkline">
														<v-sparkline
															class="mt-2"
															width="70"
															height="6"
															:value="[0, 0, 0]"
															:color="theme.accent"
															smooth
															:padding="5"
															:line-width="1.5"
															stroke-linecap="round"
															gradient-direction="right"
															type="trend"
															auto-draw
														></v-sparkline>
													</div>
													<div class="pl-3">{{ stat.total.quiz.amount }}</div>
												</v-flex>
												<div
													class="caption text-center rounded-circle pa-1 grey-bg average-container"
													:style="{
														'background-color':
															stat.total.quiz.amount == 0
																? theme.light
																: stat.total.quiz.average >= 50
																? theme.success_light
																: theme.error_light,
													}"
												>
													{{ stat.total.quiz.average }}
												</div>
											</v-flex>
										</div>
									</div>
								</div>
							</v-flex>
						</v-card>
					</div>
				</template>
			</v-hover>
		</v-flex>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'Statistics',

	data: () => ({
		stats: null,
	}),

	created() {},

	mounted() {
		if (this.user.is_admin == false) {
			this.setAlert("You don't have access to this feature.")
			this.$router.push({ name: 'Dashboard' })
		}

		this.core.http
			.get('stats')
			.then(response => {
				this.stats = response.data.stats
			})
			.catch(error => {
				this.setAlert(error.response)
			})
	},
	methods: {
		...mapMutations(['setAlert', 'forceLoad']),
		getInitials(user) {
			return user.name
				.split(' ')
				.map(w => w[0])
				.join('')
				.toUpperCase()
		},
		getActivity(activity) {
			const data = Object.values(
				activity
					.map(
						a => new Date(this.core.moment(a).startOf('day')).getTime() / 1000
					)
					.reduce(function(day, curr) {
						if (typeof day[curr] == 'undefined') day[curr] = 1
						else day[curr] += 1
						return day
					}, {})
			)
			data.unshift(0, 0)
			return data
		},
	},
	computed: {
		...mapGetters(['loading', 'theme', 'user']),
	},

	watch: {},
}
</script>

<style scoped>
.stat-sparkline {
	width: 30% !important;
}
.activity-sparkline {
	width: 37% !important;
}
.card-title {
	font-size: 0.9rem !important;
}
.stat-label {
	width: 90px;
}
.average-container {
	width: 32px;
	height: 32px;
}
.stat-full-name {
	font-size: 20px !important;
	font-weight: 400;
	line-height: 2.5rem;
	letter-spacing: 0.0073529412em !important;
	font-family: 'Roboto', sans-serif !important;
}
</style>
